import { Form } from 'react-bootstrap';
import './CustomTextbox.css';

const CustomTextbox = (props) => {
  const {
    label,
    placeholder,
    value,
    onChange,
    name,
    required,
    disabled = false,
  } = props;
  const displayLabel = label || placeholder;
  const controlId = props.id || name || placeholder || 'textbox';

  return (
    <Form.Group className="textbox-wrapper">
      <Form.Control
        type="text"
        className={`custom-textbox ${props?.showError ? 'invalid' : ''}`}
        value={value}
        onChange={onChange}
        name={name}
        required={required}
        aria-required={required}
        autoComplete="off"
        id={controlId}
        disabled={disabled}
        maxLength={props.maxLength}
        data-testid={controlId}
      />
      <Form.Label className="floating-label" htmlFor={controlId}>
        {displayLabel}
        {required && <span className="required-asterisk">*</span>}
      </Form.Label>
      {props.errorMessage && props.showError && (
        <Form.Control.Feedback
          type="invalid"
          className="form-textbox-feedback-error"
          tooltip
          style={{
            padding: '0rem',
            ...(props?.showError ? { display: 'block' } : {}),
          }}
        >
          {props.errorMessage}
        </Form.Control.Feedback>
      )}
    </Form.Group>
  );
};

export default CustomTextbox;
